function toggleNav(e) {
  const body = document.body;
  const mobileNavContainer = e.target.closest('#toggle-nav');
  if (!mobileNavContainer) return;

  // Get the next sibling div element after #toggle-nav
  const nextDiv = mobileNavContainer.nextElementSibling;
  if (!nextDiv) return; // If there is no next sibling, exit early

  // Toggle the 'open' class on the next div
  if (!nextDiv.classList.contains('open')) {
    nextDiv.classList.add('open');
    mobileNavContainer.setAttribute('aria-expanded', 'true');
    body.style.overflow = 'hidden';
  } else {
    nextDiv.classList.remove('open');
    mobileNavContainer.setAttribute('aria-expanded', 'false');
    body.style.overflow = 'initial';
  }
}

function closeDropDowns() {
  const activeDropDowns = document.querySelectorAll('.dropdown.active');
  activeDropDowns.forEach((dropDown) => {
    dropDown.classList.remove('active');
    dropDown.setAttribute('aria-expanded', 'false');
  });
}
function toggleDropDown(e) {
  e.preventDefault(); // Prevent default behavior immediately

  const linkContainer = e.target.closest('.dropdown');
  if (!linkContainer) return;

  // Prevent the page reload if the clicked element is an anchor link
  if (e.target.tagName.toLowerCase() === 'a') {
    e.preventDefault(); // Ensure we prevent the default action of anchor tags
  }

  // Toggle the 'active' class for dropdown
  if (!linkContainer.classList.contains('active')) {
    closeDropDowns();
    linkContainer.classList.add('active');
    linkContainer.setAttribute('aria-expanded', 'true');
    return;
  }
  closeDropDowns();
}

function setUpMobileMenu(context) {

  // Add dropdown button events
  const mobileDropdownGroups = context.querySelectorAll('.menu-mobile .dropdown > .menu-link');
  mobileDropdownGroups.forEach((group) => {
    group.addEventListener('click', toggleDropDown);
  });

  // Fix: Use querySelector instead of getElementById
  const navToggleButton = context.querySelector('#toggle-nav');
  if (navToggleButton) {
    navToggleButton.addEventListener('click', toggleNav);
  } else {
    console.warn("Toggle button not found");
  }
}

function setUpPrimaryMenu(context) {
  const openDropDown = (e) => {
    e.currentTarget.classList.add('active');
    e.currentTarget.setAttribute('aria-expanded', 'true');
  };

  // Add events
  const dropdownGroups = context.querySelectorAll('.menu-primary .dropdown');
  dropdownGroups.forEach((group) => {
    group.addEventListener('mouseenter', openDropDown);
    group.addEventListener('mouseleave', closeDropDowns);
  });
}

(function (Drupal, once) {
  Drupal.behaviors.menu = {
    attach(context) {
      context = context || document;

      const primaryMenus = once('initPrimary', '.menu-primary', context);
      primaryMenus.forEach(setUpPrimaryMenu);

      const mobileMenus = once('initMobile', '#mobile-navigation', context);

      mobileMenus.forEach((menuContext) => {
        const navToggleButton = menuContext.querySelector('#toggle-nav');
        if (navToggleButton) {
          navToggleButton.addEventListener('click', toggleNav);
        } else {
          console.warn("Toggle button not found");
        }
      });
    }
  };
})(Drupal, once);
